export const PLATFORM_TYPE = {
  1: 'PC端',
  2: '移动端'
};

export const POSITION_TYPE = {
  1: '广告位一',
  2: '广告位二',
  3: '广告位三',
  4: '广告位四',
  5: '广告位五',
  6: '广告位六',
  7: '广告位七',
  8: '广告位八',
  9: '广告位九',
  10: '广告位十'
};
